<script setup lang="ts">
    import type { AssetWidgetData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';

    /**
     * Asset widget for images, youtube videos or background videos
     * value contains a list of assets (otherwise rendered as gallery)
     * in case of an image, we need an image observer to check if the image is actually in the viewport before we load it
     */

    defineProps<IWidgetProps<AssetWidgetData>>();
</script>
<template>
    <lazy-mol-image-gallery
        v-if="data.value"
        :images="data.value"
        :style="data.style"
        :caption="data.caption"
        class="cms-asset-widget" />
</template>
